// TODO generate from Swagger config

import appID from 'api/appID';
import 'api/warnings';
import { stripInternalsFromAPIArguments, unwrapAPIResponse } from 'api/utils';
import ForStractionServiceAPI from 'for-straction-service-api';

function promisify<T>(f: any, thisContext?: any): (...args: any[]) => Promise<T> {
    return function () {
        const args = Array.prototype.slice.call(arguments);
        return new Promise((resolve, reject) => {
            args.push((err: any, result: any) => err !== null ? reject(err) : resolve(result));
            f.apply(thisContext, args);
        });
    }
}

interface APIInstance {
    readonly name: string;
    readonly [methodName: string]: any;
}

interface APIClass {
    new(): APIInstance;
}

const API: { [className: string]: any } = {};

for (let className in ForStractionServiceAPI) {
    if (className.indexOf('Api') !== -1) {
        Object.defineProperty(API, className, {
            get: (function (cls: APIClass, className: string) {
                let
                    originalInstance: any,
                    convertedInstance: APIInstance;
                return function () {
                    if (!convertedInstance) {
                        originalInstance = new cls();
                        convertedInstance = { name: className } as unknown as APIInstance;
                        for (var methodName in originalInstance) {
                            if (typeof (originalInstance as any)[methodName] === 'function') {
                                (convertedInstance as any)[methodName] = ((method: any) => function (...args: any[]) {
                                    if ((method.length || method.Length) - 2 === args.length + 1) {
                                        args.push({}); //a dirty hack, make options optional; Length is assigned in warnings.js
                                    }

                                    return promisify(method, originalInstance)(appID, ...stripInternalsFromAPIArguments(args))
                                        .then((response: any) => response && unwrapAPIResponse(response));
                                })(originalInstance[methodName]);
                            }
                        }
                    }

                    return convertedInstance;
                }
            })(ForStractionServiceAPI[className], className)
        })
    }
};


export interface APIMethod<R> { (...args: any): Promise<R>; }

export function getAPIMethod<R = void>(className: string, methodName: string): APIMethod<R> {
    const cls = API[className] || API[className += 'Api'];
    if (!cls) {
        throw new Error(`API class ${className}Api does not exist.`);
    }

    const mtd =
        cls[methodName] ||
        cls[methodName = (
            className[0].toLowerCase() +
            className.replace(/(Api)?$/, '').slice(1) +
            methodName[0].toUpperCase() +
            methodName.slice(1) +
            'Get'
        )] ||
        cls[methodName = methodName.slice(0, -3) + 'Put'];
    if (!mtd) {
        throw new Error(`API method ${className}.${methodName} does not exist.`);
    }

    return mtd;
}